var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "58402465-d50b-4a28-baf8-db8a4e47ab8d",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 215,
    height: 140,
    viewBox: "0 0 215 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ee3dbc19-61b2-4228-ba83-d6cfc79984a3",
    y1: 99.46,
    x2: 215,
    y2: 99.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff638a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ff9a"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Notch") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 215,
    height: 140,
    style: {
      fill: "#262728"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,140H215V68s-113.25-1-122.49-.74C69.75,67,82.58,132.38,73.83,132S77.75,68,52,68H0Z",
    style: {
      fill: "#fff",
      opacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,67,95.5,67c-28.17,0-14,65-21.67,65-8,0,4.67-65-22.83-65C32.17,67,0,67,0,67",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#ee3dbc19-61b2-4228-ba83-d6cfc79984a3)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotch);
export default __webpack_public_path__ + "static/media/Notch.5c0924f8.svg";
export { ForwardRef as ReactComponent };